/**
 * 默认生成 6-10 位随机码,可支持传入固定长度生成随机码
 * @param length
 * @returns
 */
export const getRandomCode = (length?: number) => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''

  // 确定最终生成的长度
  const finalLength =
    typeof length === 'number'
      ? Math.max(0, Math.floor(length)) // 处理负数/小数情况
      : Math.floor(Math.random() * 5) + 6 // 6-10随机数

  // 生成随机字符串
  for (let i = 0; i < finalLength; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    result += characters[randomIndex]
  }

  return result
}
